// NOTE: Jake: 2019-09-05 - WEBUI-2465
// https://github.com/darrachequesne/spring-data-jpa-datatables

import { GenericApi } from '~/api/generic-api';

if (!jQuery) {
	throw new Error('Must import jQuery before this file.');
}
const paramFn = GenericApi.encodeQueryParamsJQuery;
if (!paramFn) {
	throw new Error(
		'Expected "encodeQueryParamsJQuery" to exist on GenericApi class.',
	);
}
jQuery.param = paramFn;
